import React from 'react';

import { StyledCartIndicator } from './CartIndicator.styles';

import { CartIndicatorProps } from './CartIndicator.types';

const CartIndicator = ({
  cartProductCountContent = null,
  cartProductCount = 0,
  cartIcon,
  isDisplayedIfCartEmpty = true,
  isProductCountDisplayedIfCartEmpty = true,
  componentClassname = 'cart-indicator',
  customClassnames = '',
  customStyle = '',
}: CartIndicatorProps) => {
  if (isDisplayedIfCartEmpty && cartProductCount <= 0) {
    return null;
  }
  return (
    <StyledCartIndicator
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
    >
      {cartIcon && (
        <div className={`${componentClassname}__icon`}>{cartIcon}</div>
      )}
      {((!isProductCountDisplayedIfCartEmpty && cartProductCount > 0) ||
        isProductCountDisplayedIfCartEmpty) && (
        <div className={`${componentClassname}__product-count`}>
          {cartProductCountContent ||
            (cartProductCount < 0 ? 0 : cartProductCount)}
        </div>
      )}
    </StyledCartIndicator>
  );
};
CartIndicator.displayName = 'CartIndicator';

export default CartIndicator;
